<template>
  <div>
    <button class="mdc-fab mdc-fab--mini" @click="onClick()">
      <div class="mdc-fab__ripple"></div>
      <i class="fa fa-map-marker"></i>
      <div class="hole-cover"></div>
      <i class="fa fa-plus"></i>
      <div class="mdc-fab__touch"></div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

button {
  background-color: $light-blue;
  border: 1px solid $blue;
  box-shadow: none !important;
  min-width: 4px;
  min-height: 4px;
  max-width: 26px;
  max-height: 26px;
  font-size: 18px;
  margin: 0 0.25rem;

  i {
    color: $blue;
  }

  .hole-cover {
    background-color: $blue;
    position: absolute;
    top: 6px;
    width: 6px;
    height: 6px;
  }

  .fa-plus {
    color: $light-blue;
    font-size: 9px;
    position: absolute;
    top: 5px;
  }
}
</style>
